import { __cSearchService } from '@/services/client/__c.search.service'
import { useQuery } from '@tanstack/react-query'

export function useSearchProductsQuery(keyword: string) {
  return useQuery({
    queryKey: ['searchProducts', keyword],
    queryFn: () => __cSearchService.searchProducts(keyword),
    staleTime: 1000 * 60 * 5, // Khớp với server (5 phút)
  })
}

export function useSpotlightSearchQuery(params: {
  keyword: string
  page: number
  category?: string
  limit?: number
}) {
  return useQuery({
    queryKey: ['spotlightSearch', params],
    queryFn: () => {
      return __cSearchService.spotlightSearch(params)
    },
    // staleTime: 1000 * 60 * 5, // Khớp với server (5 phút)
  })
}

// export const useSpotlightSearchQuery = (keyword: string) => {
//   const fetcher = useCallback(
//     async ({ pageParam = 1 }) => {
//       const response = await searchService.spotlightSearch(keyword, pageParam)

//       const formattedResponse =
//         ProductFormatter.reFormatProductsSpotlightResponse(
//           response?.products || []
//         )

//       return {
//         data: formattedResponse || [],
//         pageNumber: pageParam,
//         has_next_page: response?.pagination.has_next_page,
//       }
//     },
//     [keyword]
//   )

//   return useInfiniteQuery({
//     initialPageParam: 1,
//     queryKey: ['spotlightSearch', keyword],
//     queryFn: fetcher,
//     retry: false,
//     refetchOnWindowFocus: false,
//     getNextPageParam: (lastPage) =>
//       lastPage?.has_next_page ? undefined : lastPage.pageNumber + 1,
//   })
// }
